import React from 'react';

const STATS = [
    { count: 17, label: 'FCA Core Disclosure sections', pink: true },
    { count: 73, label: 'Structured questions in the module', pink: true },
    { count: 5, label: 'Stakeholder types — one platform', pink: true },
];

const GLOWS = [
    { top: -80, left: -80, size: 400, c: 'rgba(74,103,255,0.28)' },
    { bottom: -80, right: -60, size: 360, c: 'rgba(252,119,133,0.24)' },
];

const PiscesStatsBand = () => (
    <section className="lp-stats lp-stats--glow">
        <div className="lp-stats-bg" aria-hidden="true">
            {GLOWS.map((g, i) => (
                <i key={i} style={{ top: g.top != null ? g.top + 'px' : 'auto', bottom: g.bottom != null ? g.bottom + 'px' : 'auto', left: g.left != null ? g.left + 'px' : 'auto', right: g.right != null ? g.right + 'px' : 'auto', width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(76px)' }} />
            ))}
        </div>
        <div className="lp-stats-grid">
            {STATS.map((s, i) => (
                <div key={i} data-lp-reveal data-lp-delay={i * 80}>
                    <div className={`lp-stat-num ${s.pink ? 'pink' : ''}`} data-count={s.count}>{s.count}</div>
                    <div className="lp-stat-label">{s.label}</div>
                </div>
            ))}
        </div>
        <p className="lp-stats-cap">The only platform purpose-built around FCA PS 25/6 and LSE PSM Appendix 2.</p>
    </section>
);

export default PiscesStatsBand;
